const divModalEquipService = {
  text: 'Select a Site'
};

export default divModalEquipService;
